import "./UploadedFile.scss";

interface UploadedFileProps {
  url: string;
}

export const UploadedFile: React.FC<UploadedFileProps> = ({ url }) => {
  return (
    <>
      <p>Uploaded File:</p>
      <div className="upload-file">
        <a href={url} target="_blank" rel="noreferrer">
          <div className="d-flex">
            <img
              className="img-width"
              src={require("../../images/pdf.png")}
              alt="img"
            />
            <p className="document-topic">
              {url?.substring(url?.lastIndexOf("/") + 1)}
            </p>
          </div>
        </a>
      </div>
    </>
  );
};
